import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Message, MessageBox } from 'element-ui';
import util from '@/libs/util.js';
import router from '@/router';
import api from '@/api';
import store from '@/store/index';
export default {
  namespaced: true,
  actions: {
    /**
     * @description 登录
     * @param {Object} context
     * @param {Object} payload username {String} 用户账号
     * @param {Object} payload password {String} 密码
     * @param {Object} payload route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    login: function login(_ref, formData) {
      var dispatch = _ref.dispatch,
          commit = _ref.commit;
      return new Promise( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(resolve, reject) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  api.login(formData).then( /*#__PURE__*/function () {
                    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
                      return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              util.cookies.set('token', res.data.token);
                              resolve(res);
                              _context.next = 4;
                              return dispatch('load');

                            case 4:
                              _context.next = 6;
                              return dispatch('d2admin/user/set', {
                                name: res.data.nickName,
                                isLogin: true
                              }, {
                                root: true
                              });

                            case 6:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    return function (_x3) {
                      return _ref3.apply(this, arguments);
                    };
                  }()).catch(function (err) {
                    reject(err);
                  });

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x, _x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },

    /**
     * @description 注销用户并返回登录页面
     * @param {Object} context
     * @param {Object} payload confirm {Boolean} 是否需要确认
     */
    logout: function logout(_ref4) {
      var commit = _ref4.commit,
          dispatch = _ref4.dispatch;

      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref5$confirm = _ref5.confirm,
          confirm = _ref5$confirm === void 0 ? false : _ref5$confirm;

      /**
       * @description 注销
       */
      function logout() {
        return _logout.apply(this, arguments);
      } // 判断是否需要确认


      function _logout() {
        _logout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  // 删除cookie
                  util.cookies.remove('token');
                  util.cookies.remove('uuid');
                  store.commit('d2admin/permission/setFet', false); // 清空 vuex 用户信息

                  _context3.next = 5;
                  return dispatch('d2admin/page/closeAll', {}, {
                    root: true
                  });

                case 5:
                  _context3.next = 7;
                  return dispatch('d2admin/user/set', {}, {
                    root: true
                  });

                case 7:
                  // 跳转路由
                  router.push({
                    name: 'login'
                  });

                case 8:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));
        return _logout.apply(this, arguments);
      }

      if (confirm) {
        commit('d2admin/gray/set', true, {
          root: true
        });
        MessageBox.confirm('确定要注销当前用户吗', '注销用户', {
          type: 'warning'
        }).then(function () {
          commit('d2admin/gray/set', false, {
            root: true
          });
          logout();
        }).catch(function () {
          commit('d2admin/gray/set', false, {
            root: true
          });
          Message({
            message: '取消注销操作',
            duration: '1000'
          });
        });
      } else {
        logout();
      }
    },

    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} context
     */
    load: function load(_ref6) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var dispatch;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dispatch = _ref6.dispatch;
                _context4.next = 3;
                return dispatch('d2admin/user/load', null, {
                  root: true
                });

              case 3:
                _context4.next = 5;
                return dispatch('d2admin/init/load', null, {
                  root: true
                });

              case 5:
                _context4.next = 7;
                return dispatch('d2admin/theme/load', null, {
                  root: true
                });

              case 7:
                _context4.next = 9;
                return dispatch('d2admin/transition/load', null, {
                  root: true
                });

              case 9:
                _context4.next = 11;
                return dispatch('d2admin/page/openedLoad', null, {
                  root: true
                });

              case 11:
                _context4.next = 13;
                return dispatch('d2admin/menu/asideLoad', null, {
                  root: true
                });

              case 13:
                _context4.next = 15;
                return dispatch('d2admin/size/load', null, {
                  root: true
                });

              case 15:
                _context4.next = 17;
                return dispatch('d2admin/color/load', null, {
                  root: true
                });

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }
};